import React, { useState, useEffect } from 'react'
import { Panel, Row, Icon, Table, ButtonGroup, IconButton, Message } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { getDownloadFileCancel } from '../../redux/actions/cancelOfProject'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'

export default function CancelProjectHistoryWidget({
  data,
  header,
  schemaButton,
  onSuccess = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [isFileError, setIsFileError] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      const file = await getDownloadFileCancel(projectId, fileObj.id, fileObj.fileType)
      const fileName = fileObj.name
      downloadFile(file, fileName)
      setIsFileError()
    } catch (e) {
      setIsFileError('ดาวน์โหลด')
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      const file = await getDownloadFileCancel(projectId, fileObj.id, fileObj.fileType)
      const fileName = fileObj.name
      previewFile(file, fileName)
      setIsFileError()
    } catch (e) {
      setIsFileError('แสดง')
    }
    doneLoading()
  }

  return (
    <>
      <Panel header={header} collapsible shaded defaultExpanded>
        {isFileError && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="error" description={`${isFileError}ไม่สำเร็จ`} />
          </Row>
        )}
        <Table autoHeight height={300} wordWrap bordered data={data ? [...data] : []}>
          <Column width={60}>
            <HeaderCell>ครี่งที่</HeaderCell>
            <Cell dataKey="seq" />
          </Column>

          <Column width={140}>
            <HeaderCell>วันที่เสนอ</HeaderCell>
            <Cell dataKey="requestDate" />
          </Column>

          <Column width={200}>
            <HeaderCell>เหตุผล</HeaderCell>
            <Cell dataKey="requestReason" />
          </Column>

          <Column width={100}>
            <HeaderCell>ผู้เสนอ</HeaderCell>
            <Cell dataKey="requestor" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>เอกสารประกอบ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  rowData.file.path && (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={(e) => onPreview(rowData.file)}
                      />
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => onDownload(rowData.file)}
                      />
                    </ButtonGroup>
                  )
                )
              }}
            </Cell>
          </Column>

          <Column width={140}>
            <HeaderCell>วันที่พิจารณา</HeaderCell>
            <Cell dataKey="approveDate" />
          </Column>

          <Column width={300}>
            <HeaderCell>เหตุผลการส่งกลับดำเนินการ/ดำเนินคดีตามกฎหมาย</HeaderCell>
            <Cell dataKey="approvedReason" />
          </Column>

          <Column width={130}>
            <HeaderCell>ผลการพิจารณา</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <span>
                    {rowData.isApproved ? 'อัยการสั่งฟ้อง/ยกเลิกโครงการ' : 'ส่งกลับดำเนินการ'}
                  </span>
                )
              }}
            </Cell>
          </Column>

          <Column width={100}>
            <HeaderCell>ผู้อนุมัติ</HeaderCell>
            <Cell dataKey="approver" />
          </Column>

          <Column width={165} align="center">
            <HeaderCell>เอกสารประกอบการพิจารณา</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  rowData.requestSummaryFile.path && (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={(e) => onPreview(rowData.requestSummaryFile)}
                      />
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => onDownload(rowData.requestSummaryFile)}
                      />
                    </ButtonGroup>
                  )
                )
              }}
            </Cell>
          </Column>

          <Column width={235} align="center">
            <HeaderCell>เอกสารประกอบการผลการยกเลิกโครงการ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  rowData.approvedFile.path && (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={(e) => onPreview(rowData.approvedFile)}
                      />
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => onDownload(rowData.approvedFile)}
                      />
                    </ButtonGroup>
                  )
                )
              }}
            </Cell>
          </Column>
        </Table>
        <br />
        {schemaButton?.checkButton && (
          <ApproverList
            approveType={10}
            projectversionId={projectId}
            style={{ marginRight: 10 }}
            buttontext={schemaButton?.checkButton}
            fetchButton={(disabled) =>
              schemaButton?.fetchButton && (
                <FetchNewApprover
                  approveType={10}
                  projectversionId={projectId}
                  style={{ marginRight: 10, marginBottom: 10 }}
                  buttontext={schemaButton?.fetchButton}
                  onSuccess={onSuccess}
                  disabled={disabled}
                />
              )
            }
          />
        )}
        {schemaButton?.cancelButton && (
          <CancelApprovalList
            approveType={10}
            projectversionId={projectId}
            style={{ marginRight: 10 }}
            buttontext={schemaButton?.cancelButton}
            onSuccess={onSuccess}
          />
        )}
      </Panel>
    </>
  )
}
